import axios from 'axios';

const deleteReminder = (id, payload) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/reminder/${id}/delete`, payload)
    .then(res => res)
    .catch(err => err);
};

export default deleteReminder;
